/**
* 左边菜单
*/ 
<template>
  <el-menu
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#fff"
    text-color="#303133"
    active-text-color="#2772c7"
  >
    <div class="logobox">
      <img class="logoimg" src="static/title.png" alt="" />
    </div>
    <el-menu-item
      v-for="menu in filteredMenuItems"
      :index="'/' + menu.url"
      :key="menu.menuid"
    >
      <i :class="menu.icon"></i>
      <span>{{ menu.menuname }}</span>
    </el-menu-item>
    <el-submenu
      v-for="menu in filteredSubmenus"
      :key="menu.menuid"
      :index="menu.menuname"
    >
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.menus"
          :index="'/' + chmenu.url"
          :key="chmenu.menuid"
        >
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from "../api/userMG";
export default {
  name: "leftnav",
  data() {
    return {
      activeRoute: "",
      collapsed: false,
      allmenu: [],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    let user = JSON.parse(localStorage.getItem("user_info"));
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          url: "index/work",
          hasThird: null,
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-order",
          menuname: "用工中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "任务列表",
              hasThird: "N",
              url: "task/taskList",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "用工结算单",
              hasThird: "N",
              url: "task/employmentStatement",
              menus: null,
            },
            {
              menuid: 23,
              icon: "",
              menuname: "用工结算明细",
              hasThird: "N",
              url: "task/employmentStatementDesc",
              menus: null,
            },
            {
              menuid: 24,
              icon: "",
              menuname: "自由职业者列表",
              hasThird: "N",
              url: "task/professionalList",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "余额管理",
              hasThird: "N",
              url: "payCenter/balanceManage",
              menus: null,
            },
            {
              menuid: 52,
              icon: "",
              menuname: "充值记录",
              hasThird: "N",
              url: "payCenter/rechargeRecord",
              menus: [
                {
                  menuid: 52,
                  icon: "",
                  menuname: "开票申请",
                  hasThird: "N",
                  url: "payCenter/applybilling",
                  menus: null,
                },
              ],
            },
            {
              menuid: 53,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/billingRecordList",
              menus: null,
            },
            {
              menuid: 55,
              icon: "",
              menuname: "电子回单",
              hasThird: "N",
              url: "payCenter/electronicReceipt",
              menus: null,
            },
          ],
        },
        {
          menuid: 7,
          icon: "el-icon-s-platform",
          menuname: "管理中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 71,
              icon: "",
              menuname: "合同管理",
              hasThird: "N",
              url: "manageCenter/contractManage",
              menus: null,
            },
          ],
        },
        {
          menuid: 6,
          icon: "el-icon-menu",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 61,
              icon: "",
              menuname: "自由职业者结算统计",
              hasThird: "N",
              url: "dataCenter/ReceivableTransactionStatistics",
              menus: null,
            },
            {
              menuid: 62,
              icon: "",
              menuname: "商户结算统计",
              hasThird: "N",
              url: "dataCenter/BusinessStatistics",
              menus: null,
            },
            {
              menuid: 63,
              icon: "",
              menuname: "批次明细交易信息查询",
              hasThird: "N",
              url: "dataCenter/batchmation",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };
    // 风控
    let riskContro = {
      success: true,
      data: [
        {
          menuid: 2,
          icon: "el-icon-s-order",
          menuname: "用工中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 22,
              icon: "",
              menuname: "结算商户",
              hasThird: "N",
              url: "task/merchantList",
              menus: null,
            },
            {
              menuid: 23,
              icon: "",
              menuname: "用工结算明细",
              hasThird: "N",
              url: "task/employmentStatementDesc",
              menus: null,
            },
            {
              menuid: 24,
              icon: "",
              menuname: "自由职业者列表",
              hasThird: "N",
              url: "task/professionalList",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/invoiceRecord",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-menu",
          menuname: "数据中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 42,
              icon: "",
              menuname: "商户结算统计",
              hasThird: "N",
              url: "dataCenter/BusinessStatistics",
              menus: null,
            },
            {
              menuid: 41,
              icon: "",
              menuname: "自由职业者结算统计",
              hasThird: "N",
              url: "dataCenter/ReceivableTransactionStatistics",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    // 代理
    let agent = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          hasThird: null,
          url: "agent/index",
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-data",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "批次统计",
              hasThird: "N",
              url: "agent/agentStatistics",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "商户统计",
              hasThird: "N",
              url: "agent/agentMerchantStatistics",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-custom",
          menuname: "商户管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "商户列表",
              hasThird: "N",
              url: "agent/merchantList",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-s-cooperation",
          menuname: "档案中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: "",
              menuname: "档案列表",
              hasThird: "N",
              url: "agent/agentRate",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "余额管理",
              hasThird: "N",
              url: "payCenter/balance",
              menus: null,
            },
            {
              menuid: 52,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/invoiceRecord",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    // 销售
    let sales = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          hasThird: null,
          url: "sales/index",
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-data",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "批次统计",
              hasThird: "N",
              url: "sales/salesBatchStatistics",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "商户统计",
              hasThird: "N",
              url: "sales/salesMerchantStatistics",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-custom",
          menuname: "商户管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "商户列表",
              hasThird: "N",
              url: "sales/merchantList",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: "",
              menuname: "余额管理",
              hasThird: "N",
              url: "payCenter/balance",
              menus: null,
            },
            {
              menuid: 42,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/invoiceRecord",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-s-order",
          menuname: "用工中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "用工结算明细",
              hasThird: "N",
              url: "task/employmentStatementDesc",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };
    if (user.roleId == 2) {
      // 风控
      this.allmenu = riskContro.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 3) {
      this.allmenu = agent.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 4) {
      this.allmenu = sales.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else {
      // 普通商户
      this.allmenu = res.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });

      if (
        this.$route.path == "/payCenter/applybilling" ||
        this.$route.path == "/payCenter/invoiceDetail"
      ) {
        this.activeRoute = "/payCenter/billingRecordList";
      }
      if (this.$route.path == "/task/employmentStatementDetail") {
        this.activeRoute = "/task/employmentStatement";
      }
    }
  },
  methods: {},
  computed: {
    filteredMenuItems() {
      return this.allmenu.filter((menu) => menu.menus === null);
    },
    filteredSubmenus() {
      return this.allmenu.filter((menu) => menu.menus !== null);
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #fff !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  /* border-right: 1px solid #8c8c8c; */
  background: #fff;
  padding: 10px 0px;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
  position: relative;
  z-index: 2;
}
.logoimg {
  height: 40px;
}
.el-menu-item:hover,
.el-submenu__title:hover,
.el-menu-item.is-active {
  outline: 0;
  color: #2772c7 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue